import { TPatient } from 'src/types/patient'
import ConsultSMS from 'src/components/sms-modal/consult-sms.component'
import { CurecallModalContainer } from '@honestica/curecall-ui'
// import { CurecallToggle } from '@honestica/curecall-ui' // COMMENTED OUT: Uncomment to re-enable SMS filter toggle
import { useTranslation } from 'react-i18next'
import { TPatientFollowup } from 'src/types/followup'
import { useCurrentProject } from 'src/providers/current-project.provider'
// import { useState } from 'react' // COMMENTED OUT: Uncomment to re-enable SMS filter toggle

type Props = {
  isOpen: boolean
  patient: Pick<TPatient, 'id' | 'firstname' | 'lastname'>
  onToggle: VoidFunction
  currentPatientFollowup: Pick<TPatientFollowup, 'id' | 'FollowupId'>
}

const SMSModal = ({ isOpen, patient, onToggle, currentPatientFollowup }: Props) => {
  const { t } = useTranslation()
  const { getFollowupById } = useCurrentProject()

  // Show all SMS by default - set to undefined instead of currentPatientFollowup.id to display all messages
  const filterByPatientFollowupId = undefined

  // COMMENTED OUT: Toggle functionality to filter SMS by followup
  // To re-enable: replace the line above with the commented useState and function below, and uncomment the toggle UI
  // const [filterByPatientFollowupId, setFilterByPatientFollowupId] = useState<number | undefined>(
  //   currentPatientFollowup.id, // Set to currentPatientFollowup.id to filter by default
  // )
  // const handleChangeShowAllSms = async (showAllMessages: boolean) => {
  //   // The update of filterByPatientFollowupId will re-trigger the call to useQuery and fetch new data
  //   setFilterByPatientFollowupId(showAllMessages ? undefined : currentPatientFollowup.id)
  // }

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.close')}
      isOpen={isOpen}
      toggle={onToggle}
      dialogClassName="c-max-w-[1000px] [&>div]:c-flex [&>div]:c-flex-col"
      bodyClassName="tw-p-0"
    >
      <div className="c-pt-6 c-px-8 c-pb-4 c-border-b c-border-b-grey-200">
        <h3>{t('components.sms.sms-exchanges-with-patient')}</h3>
        <p className="c-text-base c-text-grey-600">
          {t('components.sms.find-followup-sms-exchanges-with-date', {
            followupName: getFollowupById(currentPatientFollowup.FollowupId)?.name || '',
          })}
        </p>
        {/* COMMENTED OUT: Toggle to filter SMS by followup - currently showing all SMS by default */}
        {/* To re-enable: uncomment this div and the handleChangeShowAllSms function above */}
        {/* <div className="c-w-max">
          <CurecallToggle
            isEnabled={!filterByPatientFollowupId}
            onChange={handleChangeShowAllSms}
            leftLabel={t('components.sms.show-all-sms')}
          />
        </div> */}
      </div>
      <ConsultSMS
        patient={patient}
        currentPatientFollowup={currentPatientFollowup}
        filterByPatientFollowupId={filterByPatientFollowupId}
      />
    </CurecallModalContainer>
  )
}

export { SMSModal }
